import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Box, List, ListItem, Typography, ListItemText } from '@material-ui/core';

import { useStyles, listTextStyles, customCardStyles } from './SkuAccounting.styled';
import { SkusActions } from 'state/modules/skus';
import { withRouter } from 'react-router-dom';
import { UpdateAccounting } from 'components/Modals/Skus';
import { Card } from 'components/UI';
import i18n from 'i18n-js';

const SkuAccounting = ({ id }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const listClasses = listTextStyles();
  const cardClasses = customCardStyles();
  const { sku } = useSelector((state) => state.skus);
  const [openAccountingModal, setOpenAccountingModal] = useState(false);
  const taxesEnabled = useSelector((state) => state.config.settings?.core?.receivable?.taxes);
  const editable = !sku?.frozen_time;

  useEffect(() => {
    if (id) {
      dispatch(SkusActions.fetchSkuById(id));
    }
  }, [id]); // eslint-disable-line

  /**
   * Parse sku data
   * @param {object} sku Object with sku data
   */
  const getSkuData = (sku = {}) => {
    const skuInfo = [
      {
        label: `${i18n.t(`skus.sku_accounting`)}:`,
        value: sku?.accounting_type?.is_revenue
          ? i18n.t(`skus.wizard.revenue_label`)
          : sku?.accounting_type?._type === 'EXPENSE' && !sku?.accounting_type?.is_revenue
            ? i18n.t(`skus.wizard.discount_label`)
            : i18n.t(`skus.wizard.hold_label`),
      },
      { label: `${i18n.t(`skus.account_type`)}:`, value: sku?.accounting_type?.name || '-' },
    ];

    if (taxesEnabled !== false) {
      const taxes = [
        { label: `${i18n.t(`skus.tax_type`)}:`, value: sku?.taxing_choice || '-' },
        {
          label: `${i18n.t(`skus.default_tax_rate`)}:`,
          value: sku?.tax_rate_default ? `${sku?.tax_rate_default}` : '-',
        },
      ];
      skuInfo.push(...taxes);
    }

    return skuInfo;
  };

  const handleOpenEditAccountingModal = () => {
    setOpenAccountingModal((prevState) => !prevState);
  };
  /**
   * Vertical menu list
   * It has the label and the function for each action
   */
  const items = [
    {
      title: i18n.t('skus.edit_accounting'),
      onClick: handleOpenEditAccountingModal,
    },
  ];

  return (
    <Card
      menuItems={editable ? items : undefined}
      menuPermissions={{
        action: 'update',
        subject: 'invoice_item_type',
        type: 'can',
      }}
      title={i18n.t('skus.accounting')}
      headerActionType="vertical"
      contentRootClasses={cardClasses}
    >
      <Box className={classes.cardContentPadding}>
        <List className={classes.skuList}>
          {getSkuData(sku).map((val, index) => (
            <ListItem key={index} className={classes.skuListItem}>
              <ListItemText
                classes={{
                  root: val.classes || listClasses.root,
                  primary: listClasses.primary,
                  secondary: listClasses.secondary,
                }}
                primary={val.label}
                secondary={
                  <Box
                    display="flex"
                    component="span"
                    flexDirection="column"
                    className={!val.classes ? classes.textRight : ''}
                  >
                    <Typography variant="body2" component="span" color="textSecondary">
                      {val.value}
                    </Typography>
                  </Box>
                }
              />
            </ListItem>
          ))}
        </List>
      </Box>
      {openAccountingModal && (
        <UpdateAccounting
          id={id}
          open={openAccountingModal}
          handleClick={handleOpenEditAccountingModal}
        />
      )}
    </Card>
  );
};

SkuAccounting.propTypes = {
  id: PropTypes.any,
};

export default withRouter(SkuAccounting);
